import { FC } from 'react'

import Edito, { EditoProps } from '..'
import Podcast, { PodcastProps } from '../../Podcast'

export type EditoPodcastProps = EditoProps & {
  podcastProps?: PodcastProps[]
}

const EditoPodcast: FC<EditoPodcastProps> = ({ podcastProps, ...props }) => {
  return (
    <Edito
      {...props}
      {...(podcastProps &&
        podcastProps.length > 0 && {
          media: (
            <>
              {podcastProps.map((podcast, index) => (
                <Podcast {...podcast} key={index} color={props.color} />
              ))}
            </>
          ),
        })}
    />
  )
}

export default EditoPodcast
